import styled from 'styled-components';
import Button from '~components/Button';

export const TransparentButton = styled(Button)`
  padding: 17px 64px;
  font-size: 16px;
  font-weight: 400;
  background-color: transparent;
  color: white;
  border: 2px solid white;
  cursor: pointer;

  &:hover {
    background-color: white;
    color: grey;
  }
`;
